"use strict";

exports.__esModule = true;
exports.default = void 0;
let idCounter = 0;
var _default = prefix => {
  const id = ++idCounter;
  return `${prefix}-${id}`;
};
exports.default = _default;
//# sourceMappingURL=uniqueId.js.map